import { Pipe, PipeTransform } from '@angular/core';
import { INDRACurrencyService } from './currency.indra.service';

@Pipe({
  name: 'indraFormatNumberToLocale'
})
export class INDRAFormatNumberToLocalePipe implements PipeTransform {


  constructor(private currencyService: INDRACurrencyService) { }

  transform(value: any, locale?: string): any {
    if (!value) {
			return '';
		}
		return this.currencyService.INDRA_formatNumber(value, locale);
  }

}
